// export const BASE_URL = "http://127.0.0.1:8002"
export const BASE_URL = "https://admin.optimalonline.co.za"
